import { useQuery } from '@tanstack/react-query';

import { getPropertyImages } from '~/services/AccommodationService';

export const propertyImagesQueryKeys = {
  all: ['accommodation', 'property-images'] as const,
  details: () => [...propertyImagesQueryKeys.all, 'detail'] as const,
  detail: (propertyId: string) => [...propertyImagesQueryKeys.details(), propertyId] as const,
};

export function useGetPropertyImages({ propertyId, enabled = true }: { propertyId: string; enabled?: boolean }) {
  return useQuery({
    queryKey: propertyImagesQueryKeys.detail(propertyId),
    queryFn: async ({ signal }) => {
      const response = await getPropertyImages({ propertyId, signal });
      return response.result;
    },
    enabled: enabled && !!propertyId,
  });
}
